import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=57d44232&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=ts"
export * from "./TransactionDetail.vue?vue&type=script&lang=ts"
import style0 from "../../workbench/components/card.less?vue&type=style&index=0&id=57d44232&prod&lang=less&scoped=true&external"
import style1 from "./TransactionDetail.vue?vue&type=style&index=1&id=57d44232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d44232",
  null
  
)

export default component.exports